import { render, staticRenderFns } from "./AdminDateForm.vue?vue&type=template&id=5ca2be8c&scoped=true"
import script from "./AdminDateForm.vue?vue&type=script&lang=js"
export * from "./AdminDateForm.vue?vue&type=script&lang=js"
import style0 from "./AdminDateForm.vue?vue&type=style&index=0&id=5ca2be8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ca2be8c",
  null
  
)

export default component.exports